import { useEffect, useState, useCallback } from 'react';
import { Table, Pagination, Header, Message, Button } from 'react-frontier';
import { useUser } from '../HooksPublic';
import API from '../APIPublic';
import styles from '../style/user_account.module.scss';
import { isToday } from '../UtilPublic';
import { UserOrder } from '../ClassesPublic';
import moment from 'moment';

const PAGE_SIZE = 10;

function getOrderStatus(paid: boolean, shipped: boolean, prepared: boolean): string{
   return !paid ? 'Pendiente' : (shipped ? 'Enviado' : (prepared ? 'Listo' : 'Pagado'));
}

function getOrderType(orderMethod: number): string{
   switch (orderMethod) {
      case 1: return 'PDV';
      case 2: return 'Online';
      case 20: return 'B2B';
      case 21: return 'Personalizada';
      case 22: return 'Call Center';
      default: return 'Otro';
   }
}

var UserAccountOrders = ()=>{
   var { token }=useUser();
   var [orders, setOrders]=useState<UserOrder[]>(null);
   var [currentPage, setCurrentPage]=useState<number>(1);
   var [ordersError, setOrdersError]=useState<string>(null);
   var [hasMorePages, setHasMorePages]=useState<boolean>(false);

   var loadOrders = useCallback((page: number = 1)=>{
      setOrders(null);
      setOrdersError(null);
      var offset=(page-1)*PAGE_SIZE;
      if(!token || !token.access){
         setOrders([]);
         setHasMorePages(false);
         setOrdersError('No se encontró sesión activa. Vuelve a iniciar sesión.');
         return;
      }
      API.getUserOrders(token.access, offset, PAGE_SIZE)
         .then(res=>{
            if(res.error){
               setOrders([]);
               setHasMorePages(false);
               setOrdersError(res.message || 'No fue posible cargar tus órdenes');
               return;
            }
            setCurrentPage(page);
            var ordersData=res.data?.orders || [];
            setOrders(ordersData);
            setHasMorePages(ordersData.length === PAGE_SIZE);
         }).catch(()=>{
            setOrders([]);
            setHasMorePages(false);
            setOrdersError('Hubo un error cargando tus órdenes');
         })
   }, [token && token.access]);

   useEffect(()=>{
      if(!token) return;
      loadOrders(1);
   }, [token, loadOrders]);

   function handleOrderClick(orderHash: string){
      window.open(`/order/${orderHash}`, '_blank');
   }

   return <div className={styles.flexColumn}>
      <div className={styles.tableScroll}>
         <Table
            striped
            selectable
            titleCentered
            title='Mis pedidos'
            collapsingIndexes={[4]}
            headers={["No. de órden", "Tipo", "Creación", "Estatus", "Total"]}
            footer={
               orders && !ordersError && orders.length > 0 
               ? (<tr>
                  <td colSpan={5} className={styles.paginationCell}>
                     <Pagination
                        page={currentPage - 1}
                        onPageChange={(page) => loadOrders(page + 1)}
                        pageCount={hasMorePages ? currentPage + 1 : currentPage}
                     />
                  </td>
               </tr>) : null
            }
         >
            {!orders 
               && (<Table.Row>
                  <Table.Cell colSpan={5} className={styles.emptyCell}>
                     <Header text={'Cargando órdenes...'} loading />
                  </Table.Cell>
               </Table.Row>)
            }
            {ordersError 
               && (<Table.Row>
                  <Table.Cell colSpan={5} className={styles.padding20}>
                     <Message type="error" text={ordersError} />
                  </Table.Cell>
               </Table.Row>)
            }
            {orders && !ordersError && orders.length === 0 
               && (<Table.Row>
                  <Table.Cell colSpan={5} className={styles.emptyCell}>
                     <Header text="Aún no tienes órdenes" size="small" iconName="box" subtext="Cuando realices compras, aparecerán aquí." />
                  </Table.Cell>
               </Table.Row>)
            }
            {orders && !ordersError && orders.length > 0 
               && orders.map(o=>{
                  var order_type=getOrderType(o.order_method);
                  var status=getOrderStatus(o.paid, o.shipped, o.prepared);
                  return <Table.Row
                     key={`ord-${o.order_id}`}
                     onClick={() => handleOrderClick(o.order_hash)}
                     data={[
                        o.order_id 
                           ? (<Button size="small" basic text={`CCN-${o.order_id}`} onClick={() => handleOrderClick(o.order_hash)} />) : '—',
                        <span className="fr tag blue" key="type">{order_type}</span>,
                        <span
                           style={{
                              color: isToday(o.date_created) ? 'green' : '#333',
                              fontWeight: isToday(o.date_created) ? 'bold' : 'normal',
                           }}
                        >
                           {moment.unix(o.date_created).format('DD/MMM/YY')}
                        </span>,
                        <span className={`fr tag ${o.paid ? 'green' : 'yellow'}`}>{status}</span>,
                        `$${(o.total || 0).toFixed(2)}`,
                     ]}
                  />
               })
            }
         </Table>
      </div>
   </div>
};

export default UserAccountOrders;
